import { Skeleton } from '@mui/material';
import { cn } from '@/lib/utils';
import type { TrendingCardVariant } from './types';

export default function TrendingSkeleton({ variant }: { variant: TrendingCardVariant }) {
  return (
    <div
      className={cn(
        'rounded-xl overflow-hidden w-full hover:opacity-90 transition-opacity cursor-pointer',
        'px-4 py-3 flex flex-col border border-[#1F1F1F] bg-[#121212]',
        variant === 'image' ? 'row-span-2' : 'h-[140px]',
      )}
    >
      <Skeleton variant="text" sx={{ fontSize: '1rem', bgcolor: 'grey.800' }} />
      <div className="flex-1 mt-5">
        <Skeleton variant="text" sx={{ fontSize: '1rem', bgcolor: 'grey.800' }} />
        <Skeleton variant="text" width="60%" sx={{ fontSize: '1rem', bgcolor: 'grey.800' }} />
      </div>
    </div>
  );
}
